"use client"

import dynamic from "next/dynamic"
import Header from "./sections/header"
import Hero from "./hero"

const Services = dynamic(() => import("./sections/services"), {
  loading: () => <div className="py-14 md:py-16" />,
})

const Examples = dynamic(() => import("./sections/examples"), {
  loading: () => <div className="py-14 md:py-16" />,
})

const About = dynamic(() => import("./sections/about"), {
  loading: () => <div className="py-14 md:py-16" />,
})

const Technologies = dynamic(() => import("./sections/technologies"), {
  loading: () => <div className="py-14 md:py-16" />,
})

const Contact = dynamic(() => import("./sections/contact"), {
  loading: () => <div className="py-14 md:py-16" />,
})

const Footer = dynamic(() => import("./sections/footer"), {
  loading: () => <div className="py-16" />,
})

const Care = dynamic(() => import("./sections/care"), { loading: () => <div className="py-14 md:py-16" /> })

const Experience = dynamic(() => import("./sections/experience"), { loading: () => <div className="py-14 md:py-16" /> })

const Faq = dynamic(() => import("./sections/faq"), { loading: () => <div className="py-14 md:py-16" /> })

export default function LandingPage() {
  const scrollToContact = () => {
    const contactSection = document.getElementById("contact")
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: "smooth", block: "start" })
    }
  }
  return (
    <div className="min-h-screen bg-[#101318] text-[#f8fafc] overflow-hidden">
      <Header onContactClick={scrollToContact} />
      <main id="top">
        <Hero />
        <Services />
        <Care />
        <Examples />
        <Experience />
        <About />
        <Technologies />
        <Faq />
        <Contact />
      </main>
      <Footer />
    </div>
  )
}
